import React from 'react';
import { X } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';

interface CalendarModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const CalendarModal: React.FC<CalendarModalProps> = ({ isOpen, onClose }) => {
  return (
    <AnimatePresence>
      {isOpen && (
        <>
          {/* Backdrop */}
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.3 }}
            className="fixed inset-0 bg-black bg-opacity-60 backdrop-blur-sm z-50"
            onClick={onClose}
          />
          
          {/* Modal */}
          <motion.div
            initial={{ opacity: 0, scale: 0.95, y: 20 }}
            animate={{ opacity: 1, scale: 1, y: 0 }}
            exit={{ opacity: 0, scale: 0.95, y: 20 }}
            transition={{ duration: 0.3, type: "spring", damping: 25 }}
            className="fixed inset-0 z-50 flex items-center justify-center p-4"
          >
            <div className="relative bg-gray-50 rounded-3xl shadow-2xl w-full max-w-5xl h-[85vh] overflow-hidden">
              {/* Header */}
              <div className="absolute top-0 left-0 right-0 bg-white bg-opacity-95 backdrop-blur-sm border-b border-gray-100 px-8 py-6 flex items-center justify-between z-10">
                <div>
                  <h2 className="text-2xl font-bold text-gray-900">Schedule Your Strategy Session</h2>
                  <p className="text-sm text-gray-600 mt-1">Choose a time that works best for you</p>
                </div>
                <motion.button
                  whileHover={{ scale: 1.05 }}
                  whileTap={{ scale: 0.95 }}
                  onClick={onClose}
                  className="p-3 hover:bg-gray-100 rounded-full transition-all duration-200 group"
                >
                  <X className="h-5 w-5 text-gray-500 group-hover:text-gray-700" />
                </motion.button>
              </div>
              
              {/* Iframe Container with padding for header */}
              <div className="w-full h-full pt-24 bg-gray-50">
                <iframe
                  src="https://calendar.google.com/calendar/appointments/schedules/AcZssZ2-POP5HFxUDdkZD5rA_ja-j8bDrwScW-zZJU7YhBCIbqY4PpndMk_XB7T4ktep-9sz0d2GS6xw?gv=true"
                  width="100%"
                  height="100%"
                  frameBorder="0"
                  className="bg-white"
                  title="Schedule Appointment"
                />
              </div>

              {/* Decorative elements */}
              <div className="absolute -bottom-20 -right-20 w-40 h-40 bg-gray-200 rounded-full opacity-20 blur-3xl" />
              <div className="absolute -top-20 -left-20 w-40 h-40 bg-gray-300 rounded-full opacity-20 blur-3xl" />
            </div>
          </motion.div>
        </>
      )}
    </AnimatePresence>
  );
};

export default CalendarModal;
